export default __webpack_public_path__ + "static/media/dinsey-new-logo.01337586.png";